module.exports = __webpack_public_path__ + "img/icon-unicenter.75f1523f.png";